import { useState, useEffect } from "react";
import { useListCustomerProfiles } from "@/lib/api/risk/profiles";
import type { RiskCropProfile } from "@/lib/api/risk/profiles";
import { ProfileTable } from "./ProfileTable";
import {
  Dialog, DialogContent,
  DialogHeader,
  DialogTitle, DialogDescription
} from "@/components/ui/dialog";

interface EditCropProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerId: string;
  commodityType: string;
  cropYear: number;
}

export function EditCropProfileModal({
  isOpen,
  onClose,
  customerId,
  commodityType,
  cropYear,
}: EditCropProfileModalProps) {
  const [profile, setProfile] = useState<RiskCropProfile | null>(null);

  // Fetch all profiles for this customer
  const listCustomerProfilesResult = useListCustomerProfiles({
    customer_id: customerId,
    filters: {
      is_enabled: true,
      crop_year: [cropYear],
    },
  });

  const customerData = listCustomerProfilesResult?.data?.data || {};

  useEffect(() => {
    if (customerData?.profiles) {
      // Find the specific profile matching the commodity type and crop year
      const matchingProfile = customerData.profiles.find((p: RiskCropProfile) =>
        p.commodity_type === commodityType && 
        p.crop_year === cropYear
      );

      if (matchingProfile) {
        setProfile(matchingProfile);
      } else {
        // No matching profile found - close the modal
        setProfile(null);
        onClose();
      }
    }
  }, [customerData, commodityType, cropYear, onClose]);

  if (!isOpen || !profile) {
    return null;
  }

  // Always show the unified table interface
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogHeader>
        <DialogTitle></DialogTitle>
        <DialogDescription>
        </DialogDescription>
      </DialogHeader>
      <DialogContent className="sm:max-w-[600px] lg:max-w-[1300px] lg:min-w-[700px]">
        <ProfileTable
          profile={profile}
          customerId={customerId}
          onSuccess={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
